import { ReactElement } from 'react';

function CopyCreateIcon(): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M13.3334 0.833008H3.33341C2.41675 0.833008 1.66675 1.58301 1.66675 2.49967V14.1663H3.33341V2.49967H13.3334V0.833008ZM15.8334 4.16634H6.66675C5.75008 4.16634 5.00008 4.91634 5.00008 5.83301V17.4997C5.00008 18.4163 5.75008 19.1663 6.66675 19.1663H15.8334C16.7501 19.1663 17.5001 18.4163 17.5001 17.4997V5.83301C17.5001 4.91634 16.7501 4.16634 15.8334 4.16634ZM15.8334 17.4997H6.66675V5.83301H15.8334V17.4997Z"
        fill="#0075C3"
      />
    </svg>
  );
}

export default CopyCreateIcon;
